import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\RestoreDumpController::__invoke
* @see app/Http/Controllers/SAManagement/RestoreDumpController.php
* @route '/api/sa-management/dump/restore'
*/
const RestoreDumpController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RestoreDumpController.url(options),
    method: 'post',
})

RestoreDumpController.definition = {
    methods: ["post"],
    url: '/api/sa-management/dump/restore',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SAManagement\RestoreDumpController::__invoke
* @see app/Http/Controllers/SAManagement/RestoreDumpController.php
* @route '/api/sa-management/dump/restore'
*/
RestoreDumpController.url = (options?: RouteQueryOptions) => {
    return RestoreDumpController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\RestoreDumpController::__invoke
* @see app/Http/Controllers/SAManagement/RestoreDumpController.php
* @route '/api/sa-management/dump/restore'
*/
RestoreDumpController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RestoreDumpController.url(options),
    method: 'post',
})

export default RestoreDumpController